module.exports = __webpack_public_path__ + "static/media/1016868.6216450e.jpg";